import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import Geolocations from '../../../../../../ReusableFormFields/GeolocationsFields'

import { FACEBOOK_PLATFORM } from '../../../../../../../constants/selectLists/platformList'
import {
  GEO_EXCLUSIONS,
  SHOW_COUNTRIES,
  SHOW_REGIONS
} from '../../../../../../ReusableFormFields/GeolocationsFields/fields'

const stepFields = [SHOW_COUNTRIES, SHOW_REGIONS, GEO_EXCLUSIONS]

const GeotargetingStep = ({ formik, handleStepChange }) => {
  const { t } = useTranslation()

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <Step stepTitle={t('Which locations should the ads be shown in?')} handleContinue={handleContinue}>
      <Geolocations
        formik={formik}
        platform={FACEBOOK_PLATFORM}
        showCustomLocations={false}
        showWorldwide={false}
        showGeolocationsExclusions={true}
      />
    </Step>
  )
}

export default GeotargetingStep
